import { render, staticRenderFns } from "./GeneralErrorModalComponent.vue?vue&type=template&id=f6c5b9f4"
import script from "./GeneralErrorModalComponent.vue?vue&type=script&lang=js"
export * from "./GeneralErrorModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports